import React from 'react';
import HeartIcon from '../icons/HeartIcon';
import { Link } from 'react-router-dom';
import { handleViewInApp } from '../utils/deviceDetection';

function ProductCard({ product }) {
  return (
    <div className="bg-white overflow-hidden flex flex-col">
      {/* Image area — portrait ratio ~3:4 */}
      <div className="relative w-full" style={{ paddingBottom: '133.6%' }}>
        {product.images ? (
          <img
            src={product.images[0].variants ? product.images[0].variants.large : product.images[0].url}
            alt={product.title}
            className="absolute inset-0 w-full h-full object-cover"
          />
        ) : (
          <div className="absolute inset-0 bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center">
            <span className="text-gray-400 text-sm">No Image</span>
          </div>
        )}
        {product.is_sold && (
          <div className="absolute bottom-2 left-2 px-2 py-1 bg-[#f3f4f0] rounded-full">
            <span className="text-[#d52920] text-sm">Sold</span>
          </div>
        )}
        {/* Heart icon */}
        <button className="absolute bottom-2 right-2 w-7 h-7 bg-white rounded-full flex items-center justify-center shadow-sm" aria-label="Save">
          <HeartIcon />
        </button>
      </div>

      {/* Info area */}
      <div className="pt-[4px] pb-[4px] flex text-left flex-col gap-2 flex-1">
        <div>
          <p className="text-xs text-gray-400">{product.price.toFixed(2)} AED</p>
          <p className="text-base text-[#137c63]">{(product.price * 1.2).toFixed(2)} AED incl.</p>
          <p className="text-xs text-[#252d2a] truncate">{product.brand.name}</p>
          <p className="text-xs text-[#252d2a] truncate">{product.size.value}</p>
        </div>

        <Link to="/qr-code" className="w-full text-center border border-[#062319] text-[#062319] text-sm font-bold py-2 rounded-lg hover:bg-[#062319] hover:text-[#DDFDB3] transition-colors mt-auto" onClick={(e) => {
          if (window.gtag) {
            window.gtag('event', 'view_in_app_click', { product_id: product.id, product_brand: product.brand.name, product_price: product.price });
          }
          handleViewInApp(e, product.id);
        }}>
          View in app
        </Link>
      </div>
    </div>
  );
}

export default ProductCard;
